import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1933d64e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guests-mapper" }
const _hoisted_2 = { class: "guests-mapper__info-wrapper" }
const _hoisted_3 = { class: "guests-mapper__row" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "guests-mapper__row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "guests-mapper__row" }
const _hoisted_10 = { class: "guests-mapper__info-wrapper" }
const _hoisted_11 = { class: "guests-mapper__num_of_guests" }
const _hoisted_12 = { class: "guests-mapper__label" }
const _hoisted_13 = { class: "guests-mapper__num_of_guests" }

import { HousingInformation, Guests } from '@/models/public/service.model'
import { PropType } from 'vue'
import BaseNumberIncrementer from '../../BaseNumberIncrementer.vue'
import BaseIcon from '../../BaseIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HousingUnitGuestsMapper',
  props: {
  housingInfo: {
    type: Object as PropType<HousingInformation>,
    default: () => ({}),
  },
  modelValue: {
    type: Object as PropType<Guests>,
    default: () => ({}),
  },
  errors: {
    type: Object as PropType<Record<string, unknown> | undefined>,
    default: () => ({}),
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  minAdults: {
    type: Number,
    default: 0,
  },
},
  emits: ['update:modelValue'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseIcon, {
          icon: "user",
          size: 20
        }),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(__props.housingInfo.housing.max_guests) + " ", 1),
          (__props.housingInfo.housing.max_guests > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('visitors')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('visitor')), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseIcon, {
          icon: "bed",
          size: 20
        }),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(__props.housingInfo.housing.beds_count) + " ", 1),
          (__props.housingInfo.housing.beds_count > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('beds')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('bed_')), 1))
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createVNode(BaseIcon, {
          icon: "coffee",
          size: 20
        }),
        _createElementVNode("span", null, _toDisplayString(__props.housingInfo.housing.meal_plan), 1)
      ], 512), [
        [_vShow, __props.housingInfo.housing.meal_plan]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('adult')), 1),
        _createVNode(BaseNumberIncrementer, {
          amount: __props.modelValue.adults,
          "min-amount": __props.minAdults,
          "max-amount": __props.housingInfo.housing.max_guests - __props.modelValue.children,
          errors: __props.errors?.adults,
          disabled: __props.disabled,
          class: "guests-mapper__number-incrementer",
          onClickMinus: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.$emit('update:modelValue', {
              ...__props.modelValue,
              adults: Math.max(0, __props.modelValue.adults - 1),
            })
          )),
          onClickPlus: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.$emit('update:modelValue', {
              ...__props.modelValue,
              adults: __props.modelValue.adults + 1,
            })
          ))
        }, null, 8, ["amount", "min-amount", "max-amount", "errors", "disabled"])
      ]),
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('children')), 1),
        _createVNode(BaseNumberIncrementer, {
          amount: __props.modelValue.children,
          "min-amount": 0,
          "max-amount": __props.housingInfo.housing.max_guests - __props.modelValue.adults,
          errors: __props.errors?.children,
          disabled: __props.disabled,
          onClickMinus: _cache[2] || (_cache[2] = ($event: any) => (
            _ctx.$emit('update:modelValue', {
              ...__props.modelValue,
              children: Math.max(0, __props.modelValue.children - 1),
            })
          )),
          onClickPlus: _cache[3] || (_cache[3] = ($event: any) => (
            _ctx.$emit('update:modelValue', {
              ...__props.modelValue,
              children: __props.modelValue.children + 1,
            })
          ))
        }, null, 8, ["amount", "max-amount", "errors", "disabled"])
      ])
    ])
  ]))
}
}

})